import React from "react";
import PropTypes from "prop-types";
import SelectInput from "../../../common/forms/SelectInput";

const ConsultantLNFilter = React.forwardRef((props, ref) => {
  return (
    <SelectInput default="All" label="Last Name" onChange={props.onChange} options={props.names.sort()} ref={ref} />
  );
});

ConsultantLNFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  names: PropTypes.array.isRequired,
};

export default React.memo(ConsultantLNFilter);
